import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MapPin } from "lucide-react";

export default function WorksPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/projects").then((r) => setItems(r.data.items)); }, []);
  const filtered = items.filter(p => (p.name + " " + p.district + " " + p.project_type).toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">Works Management</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">Projects register</h1>
      </div>
      <div className="flex flex-wrap gap-3 items-center justify-between">
        <input placeholder="Search project, district, type…" value={q} onChange={(e)=>setQ(e.target.value)} className="input max-w-sm"/>
        <div className="text-xs text-muted-foreground">{filtered.length} of {items.length} projects</div>
      </div>
      <div className="rounded-2xl border border-border bg-card overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr>
              <th className="table-th">Project</th>
              <th className="table-th">Type</th>
              <th className="table-th">District</th>
              <th className="table-th">Contractor</th>
              <th className="table-th">Budget</th>
              <th className="table-th">Progress</th>
              <th className="table-th">Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p) => (
              <tr key={p.id} className="border-t border-border hover:bg-muted/40">
                <td className="table-cell font-medium"><Link to={`/projects/${p.id}`} className="hover:text-[hsl(var(--primary))]">{p.name}</Link></td>
                <td className="table-cell capitalize text-muted-foreground">{p.project_type.replace("_"," ")}</td>
                <td className="table-cell"><span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3"/>{p.district}</span></td>
                <td className="table-cell">{p.contractor}</td>
                <td className="table-cell">₹{(p.budget/1e5).toFixed(1)}L</td>
                <td className="table-cell">
                  <div className="flex items-center gap-2">
                    <div className="w-24 h-1.5 rounded-full bg-muted overflow-hidden"><div className="h-full bg-[hsl(var(--primary))]" style={{width:`${p.progress}%`}}/></div>
                    <span className="text-xs">{p.progress}%</span>
                  </div>
                </td>
                <td className="table-cell"><span className="badge-status-approved capitalize">{p.status.replace("_"," ")}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
